module.exports = __webpack_public_path__ + "img/book-font.b9ae2b96.svg";